import { render, staticRenderFns } from "./SlideshowImagePicker.vue?vue&type=template&id=37516050&scoped=true&"
import script from "./SlideshowImagePicker.vue?vue&type=script&lang=js&"
export * from "./SlideshowImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowImagePicker.vue?vue&type=style&index=0&id=37516050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37516050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
